import React from "react";
import { Box } from "@mui/material";
import GlobalSearchItemHeader from "./GlobalSearchItemHeader";
import AppIcon from "ui/components/icons/AppIcon";
import { iconBusiness } from "ui/components/icons";
import { FirmContent } from "data/@types/Firm";

type FirmItemProps = {
  firm: FirmContent;
};

const FirmItem = ({ firm }: FirmItemProps) => {
  return (
    <Box
      sx={{
        padding: "6px 0",
        display: "inline-grid",
        gridTemplateColumns: "25px auto",
        width: "100%",
        alignItems: "center",
      }}
    >
      <AppIcon
        icon={iconBusiness}
        sx={{ fontSize: "1em", alignSelf: "start" }}
        data-test-id="firm-icon"
      />
      <GlobalSearchItemHeader entityType="Firm" firm={firm} />
    </Box>
  );
};

export default FirmItem;
